<template>
  <div>
    <h5 class="text-center primary-color" v-show="this.$store.state.configs.ALLOW_ABOVE_MEDICATION_TEXT">
      {{computeCaption(fields_en['above_please_tell_us_more_about_yourself'], $store.state.lang.value.toLowerCase())}}
    </h5>
    <h5 class="text-center">
      {{computeCaption(fields_en['please_tell_us_more_about_yourself'], $store.state.lang.value.toLowerCase())}}
    </h5>
    <div v-if="this.$store.state.configs.SHOW_DL_BARCODE_SCAN && this.$store.state.international === false" class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <div class="col-md-6 p-0 pt-10">
            <label class="control-label">
              {{computeCaption(fields_en['scan_the_back_of_your_driver_license'], $store.state.lang.value.toLowerCase())}}
            </label>
          </div>
          <div class="col-md-6 pr-0">
            <el-button
              icon="el-icon-camera-solid"
              class="float-right w-100 p-10 scan-button primary-color"
              @click="drawer = true"
              ><span>{{computeCaption(fields_en['click_here_to_scan'], $store.state.lang.value.toLowerCase())}}</span></el-button
            >
          </div>
          <el-drawer
            v-if="allow_user_demo"
            :with-header="false"
            :append-to-body="true"
            :visible.sync="drawer"
            direction="ltr"
            size="100%"
          >
            <UserDemo
              v-on:closeScanner="closeScanner"
              v-on:getScannedData="getScannedData"
            />
          </el-drawer>
          <el-drawer
            v-else
            :with-header="false"
            :append-to-body="true"
            :visible.sync="drawer"
            direction="ltr"
            size="100%"
          >
            <BarcodeScanner
              v-on:closeScanner="closeScanner"
              v-on:getScannedData="getScannedData"
            />
          </el-drawer>
        </div>
      </div>
    </div>
      <!-- first name / last name-->
    <NameSection ref='nameSection' :configuration="nameObject" :triggerNameSectionValidation="triggerWatch"/>

    <div v-if="this.$store.state.requirements['address']">
      <Address
        id="patient"
        @updateAddress="updateAddress"
        @updateAddress2="updateAddress2"
        :same_address2="model.address2"
        :componentsInsurance="model.addressComponents"
        :checkRequired ="addressRequired"
        wizardStep="medical"
        ref="AddressComponent"
      />
      <small class="text-danger" v-if="address_error"">
        {{address_error && computeCaption(address_error, $store.state.lang.value.toLowerCase())}}
      </small>
    </div>
    <GeneticsSection ref="GeneticsSection" :configuration="geneticsObject" :triggerGeneticsWatch="triggerWatch"/>
    <div>
      <PersonIdentifierSection :configuration="personIdentifierObject" ref="personIdentifierSection" :triggerPersonIdentifierWatch="triggerWatch"/>
    </div>
    <!--DRIVER LICENSE -->
    <div class="text-center" v-if="allow_driver_license">
      <br/>
      <h5 >
        <span v-html="computeCaption(fields_en['upload_driver_license'], $store.state.lang.value.toLowerCase())"></span>
        <br/>
        <small>{{ computeCaption(fields_en['minors_quote'], $store.state.lang.value.toLowerCase()) }}</small>
      </h5>
    </div>
    <div class="row">
    <MultipleInput :caption="computeReportableCaption('driver_license_image', fields_en['driver_license'], $store.state.lang.value.toLowerCase())" :partOfSection="false" :allow="allow_driver_license" :required="required_driver_license" ref="driverLicense"></MultipleInput>
    </div>
    <!-- Kit Number Scanner -->
    <ScanningModule v-if="this.$store.state.requirements.kit_number" :text_ph="fields_en.scan_kit_text" :required="required_kit_number" ref="scanningModule"></ScanningModule>
    <QuestionsSection ref="questions" section="main"></QuestionsSection>
  </div>
</template>
<script>
  import BarcodeScanner from './BarcodeScanner'
  import UserDemo from './UserDemo'
  import {mapFields} from 'vee-validate'
  import {Autocomplete, Input, Drawer, Button, RadioGroup, Radio, RadioButton, DatePicker, CheckboxGroup, CheckboxButton} from 'element-ui'
  import {FormatterUtils} from '../../../../../utils/Formatter.js'
  import {ValidationUtils} from '../../../../../utils/Validation.js'
  import Address from '../../Utils/Sections/Address'
  import NameSection from '../../Utils/Sections/NameSection.vue'
  import QuestionsSection from '../../Utils/Sections/QuestionsSection'
  import GeneticsSection from '../../Utils/Sections/GeneticsSection.vue'
  import PersonIdentifierSection from '../../Utils/Sections/PersonIdentifierSection.vue'
  import MultipleInput from '../../Utils/Sections/MultipleInput.vue'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  import ScanningModule from '../../Utils/SubComponents/MultipleUseParts/ScanningModule'
  import {SettingsUtils} from '../../../../../utils/SiteConfigurations'
//  PATIENT NAME
//  PATIENT ADDRESS
//  PATIENT SEX
//  PATIENT DOB
//  PATIENT PHONE NUMBER
//  PATIENT EMAIL ADDRESS
//  PATIENT INSURANCE DETAILS
  export default {
    components: {
      [Input.name]: Input,
      [DatePicker.name]: DatePicker,
      [Autocomplete.name]: Autocomplete,
      [Drawer.name]: Drawer,
      [Button.name]: Button,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [RadioButton.name]: RadioButton,
      [CheckboxButton.name]: CheckboxButton,
      [CheckboxGroup.name]: CheckboxGroup,
      BarcodeScanner,
      UserDemo,
      Address,
      NameSection,
      QuestionsSection,
      GeneticsSection,
      PersonIdentifierSection,
      MultipleInput,
      ScanningModule
    },
    mixins: [FormatterUtils, ValidationUtils, TranslationsUtils, SettingsUtils],
    props: ['triggerWatch'],
    data () {
      return {
        nameObject: {},
        personIdentifierObject: {},
        geneticsObject: {},
        disabled: false,
        driverLicNrKey: 9999,
        addressRequired: true,
        dateRequired: true,
        address_error: '',
        phoneTransaction: false,
        scannedAddress: false,
        drawer: false,
        dateScanned: false,
        force_valid_address: this.isTrue(this.$store.state.configs.FORCE_VALID_ADDRESS),
        allow_user_demo: this.$store.state.configs.ALLOW_USER_DEMO,
        suggestions: [],
        smartystreets_key: this.$store.state.configs.SMARTYSTREETS_KEY,
        answers_es: {},
        answers_zh: {},
        requirements: [],
        questionErrorDate: [],
        answer_no: 'No',
        fields_en: {
          click_here_to_scan: 'Click here to scan',
          scan_the_back_of_your_driver_license: 'Scan the back of the driver license or ID',
          driver_license: 'Driver License',
          first_name: 'First Name',
          address: 'Address',
          address2: 'Address 2',
          last_name: 'Last Name',
          please_answer_to_the_best_of_your_knowledge: 'Please answer to the best of your knowledge',
          above_please_tell_us_more_about_yourself: 'The new Federal Mandate for Covid Testing requires ALL patient info to be accurate. Incorrect patient info may delay results or result in the sample being rejected.',
          please_tell_us_more_about_yourself: 'Please tell us more about yourself',
          answer_required: 'Answer required',
          scan_kit_text: 'Use scan button or type Kit number',
          upload_driver_license: 'Now upload or take a picture <b>of the front of your driver license or ID</b>',
          minors_quote: 'For minors please use the guardian driver license or ID'
        },
        model: {
          driver_license_images: [],
          driver_license_names: [],
          address: '',
          address2: '',
          present_medical: '',
          past_medical: '',
          addressComponents: {
            name: '',
            original_name: '',
            delivery_line_1: '',
            city_name: '',
            county: '',
            state_abbreviation: '',
            zipcode: '',
            plus4_code: '',
            county_fips: '',
            country: ''
          }
        },
        modelValidations: {
          driver_license_image: {
            required: this.$store.state.configs['ALLOW_DRIVER_LICENSE'] === true && this.required_driver_license === true
          },
          primary_insurance: {
            min: 5,
            required: true
          },
          present_medical: {
            min: 5,
            required: true
          },
          past_medical: {
            min: 5,
            required: true
          },
          generic_question: {
            required: true
          },
          generic_answer: {
            required: true
          }
        },
        address_smartystreets_selected: {
          invalid: false,
          error_message: 'Looks like we don\'t know this address, please make sure the address is correct',
          first_result: ''
        },
        nationality: 'US'
      }
    },
    beforeMount () {
      this.nameObject = {
        model: this.$store.state.user
      }
      this.personIdentifierObject = {
        model: this.$store.state.user
      }
      this.geneticsObject = {
        model: this.$store.state.user
      }
      this.$store.state.international = false
      this.modelValidations.driver_license_image.required = this.$store.state.configs['ALLOW_DRIVER_LICENSE'] === true && this.required_driver_license === true
    },
    methods: {
      updateAddress (data) {
        this.model.addressComponents = data
        this.address_error = ''
      },
      updateAddress2 (data) {
        this.model.address2 = data
      },
      closeScanner () {
        this.drawer = false
      },
      getScannedData (data) {
        this.drawer = false
        this.$store.state.userData['firstName'] = data['firstName']
        this.$store.state.userData['lastName'] = data['lastName']
        if (data['gender'] === '1') {
          this.$store.state.userData['gender'] = 'Male'
        } else {
          this.$store.state.userData['gender'] = 'Female'
        }
        this.$store.state.userData['dob_pretty'] = data['dob']
        this.$store.state.userData['dob'] = data['dob']
        this.$store.state.userData['dob_scanned'] = true
        this.$store.state.userData['address'] = data['address']
        this.$store.state.userData['address_scanned'] = true
        if (data['address2']) {
          this.model.address2 = data['address2']
        }
      },
      createFilter (queryString) {
        return (link) => {
          return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async validate () {
        let nameSectionValidator = await this.$refs.nameSection.validate()
        let geneticsSectionValidator = await this.$refs.GeneticsSection.validate()
        let personIdentifierValidator = await this.$refs.personIdentifierSection.validate()
        if (personIdentifierValidator) {
          localStorage.setItem('email', this.$store.state.user.email)
        }
        // Kit Number Validation
        let kitNumberBoolean = false
        if (this.$store.state.requirements.kit_number) {
          kitNumberBoolean = await this.$refs.scanningModule.validate()
          if (kitNumberBoolean) {
            this.model.kit_number = kitNumberBoolean
          }
          if (kitNumberBoolean === '') {
            kitNumberBoolean = true
          }
        } else {
          kitNumberBoolean = true
        }
        this.$store.state.medDataValidator = false
        await this.$validator.validateAll()
        this.address_error = ''
        if (this.checkRequirement('address')) {
          let addressValidation = this.$refs.AddressComponent.validate()
          if (!addressValidation) {
            this.address_error = 'All the required fields must be completed!'
            return false
          }
        }
        // call driver license images validation
        if (this.allow_driver_license) {
          let driverLicenseArr = await this.$refs.driverLicense.validate()
          if (driverLicenseArr !== false && driverLicenseArr !== undefined && driverLicenseArr.length > 0) {
            this.model.driver_license_images = driverLicenseArr[0]
            this.model.driver_license_names = driverLicenseArr[1]
          } else {
            if (this.required_driver_license) {
              return false
            }
          }
        }
        // call question validation
        this.questionError = this.$refs.questions.validate() === '' ? '' : false
        /*
        this.$store.state.dataForInsurance.dob = this.model.dob
        this.$store.state.dataForInsurance.dob_pretty = this.model.dob_pretty
        this.$store.state.dataForInsurance.gender = this.model.gender
         */
        this.$store.state.dataForInsurance.email = this.$store.state.user.email
        this.$store.state.dataForInsurance.addressComponents = this.model.addressComponents
        let isAddressValid = false
        if (this.force_valid_address && !this.address_smartystreets_selected.invalid) {
          isAddressValid = true
        }
        if (!this.force_valid_address) {
          isAddressValid = true
        }
        if ((await this.$validator.validateAll() === true) && kitNumberBoolean && nameSectionValidator && geneticsSectionValidator && personIdentifierValidator && isAddressValid && this.questionError === '') {
          this.model = {...this.model, ...this.$store.state.user}
          this.$store.state.currentData = this.model
          this.$store.state.medDataValidator = true
          return true
        } else {
          return false
        }
      },
      translateToSpanish (option) {
        if (this.$store.state.lang.value === 'ES' && this.answers_es) {
          return this.answers_es[option]
        } else {
          if (this.$store.state.lang.value === 'ZH' && this.answers_zh) {
            return this.answers_zh[option]
          } else {
            return option
          }
        }
      },
      switchInternational () {
        if (this.nationality === 'International') {
          this.$store.state.international = true
        } else {
          this.$store.state.international = false
        }
      }
    },
    computed: {
      addressFromTransaction () {
        if (this.$store.state.medicalData.address) {
          return this.$store.state.medicalData.address
        }
      },
      address2FromTransaction () {
        if (this.$store.state.medicalData.address2) {
          return this.$store.state.medicalData.address2
        }
      },
      required_driver_license () {
        return this.$store.state.configs['REQUIRED_DRIVER_LICENSE']
      },
      required_kit_number () {
        return this.checkRequirement('kit_number')
      },
      allow_driver_license () {
        return this.$store.state.configs.ALLOW_DRIVER_LICENSE
      },
      ...mapFields(['address', 'address2', 'driver_license_image'])
    },
    watch: {
      addressFromTransaction () {
        this.model.address = this.$store.state.medicalData.address
      },
      address2FromTransaction () {
        this.model.address2 = this.$store.state.medicalData.address2
      },
      '$store.state.requirements': {
        handler: function (after, before) {
          this.addressRequired = this.checkRequirement('address')
        },
        deep: true
      },
      'model.addressComponents': {
        handler: function (before, after) {
          this.$store.state.insuranceData.addressComponents = this.model.addressComponents
          this.$store.state.insuranceData.address = this.model.address
          this.$store.state.user.addressComponents = this.model.addressComponents
          this.$store.state.user.address = this.model.address
        },
        deep: true
      }
    }
  }
</script>
<style lang="scss" scoped>
@import "../../../../../assets/sass/paper/_variables.scss";

 >>>.el-select--large{
      width: 100%;
    }

 >>>.el-autocomplete{
      width: 100%;
    }

  h5{
    margin-bottom: 25px;
  }

  .display-none {
    display: none;
  }

  .generic-answer {
    margin-top: 10px;
  }

  .float-right{
    float: right;
  }

  .p-0{
    padding: 0;
  }

  .w-100{
    width: 100% !important;
  }

  .pr-0{
    padding-right: 0;
  }

  .p-10{
    padding: 10px;
  }

  .pt-10{
    padding-top: 10px;
  }

  .scan-button{
    font-size: 17px;
    background: white;
    border: 1px solid $primary-color;
    border-radius: 5px;
  }

  .line-clamp {
    text-overflow: ellipsis;
    overflow: hidden;
    /* width: 500px; */
    height: 1.2em;
    white-space: nowrap;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .d-inline-block{
    display: inline-block;
  }

  .mt-5{
    margin-top: 5px;
  }

  .mt-10{
    margin-top: 10px;
  }

  .general-inactive-section:focus-within {
    border-left-color: $primary-color !important;
  }

  @media screen and (max-width: 991px) {
    .mt-5{
      margin-top: 0;
    }

    .mb-0{
      margin-bottom: 0;
    }

     .pr-0{
      padding-left: 0;
    }
  }

  @media screen and (max-width: 365px) {
    >>> .el-radio-button--small .el-radio-button__inner {
      padding: 9px 7px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Patient/Wizard/MedicationDataStep.vue